import React from 'react'
import { Field } from 'redux-form'

import { Icon } from 'app/elements/Icon'
import { InputCheckbox, Box, Label, CheckIcon, CheckBoxContainer } from './styles'

const renderCheckboxItem = props => {
  const inputValue = props.input.value
  return (
    <InputCheckbox
      {...props}
      onChange={e => {
        const arr = [...inputValue]
        if (e.target.checked) {
          arr.push({ tipo: props.typeValue })
        } else {
          const pos = arr
            .map(arrItem => {
              return arrItem.tipo
            })
            .indexOf(props.typeValue)
          arr.splice(pos, 1)
        }
        props.input.onChange(arr)
        props.setServicesRef(e.target)
      }}
      value={props.input.value}
      type="checkbox"
    />
  )
}

function CheckboxItem({ selectedTypes = [], ...otherProps }) {
  const checked = selectedTypes.some(type => type.tipo === otherProps.typeValue)
  return (
    <CheckBoxContainer disabled={otherProps.disabled}>
      <Field component={renderCheckboxItem} {...otherProps} />
      <Box checked={checked}>
        <CheckIcon>
          <Icon width="11" height="8" icon="check" viewBox="0 0 11 8" />
        </CheckIcon>
      </Box>
      <Label>{otherProps.label}</Label>
    </CheckBoxContainer>
  )
}

export default CheckboxItem



// WEBPACK FOOTER //
// ./src/app/modules/StatementsFilterForm/FilterByServices/CheckboxItem.js